import React from 'react';
// import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client'
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthProvider';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import 'typeface-roboto'



if (process.env.NODE_ENV === 'production') {
  disableReactDevTools();
}


const container = document.getElementById('app');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      {/* <AuthProvider>
        <App /> */}
      <AuthProvider>
        <Routes>
          <Route path="/*" element={<App />} />
        </Routes>
      </AuthProvider>
      {/* </AuthProvider> */}
    </BrowserRouter>
  </React.StrictMode>
);